<template>
  <div class="container-fluid">
    <div  class="card border-primary shadow-lg">
      <div class="card-header text-white bg-primary">
        <label>{{ $t('menu.billing.invoices.title') }}</label>
      </div>

      <div class="card-body">
        <TableField
            v-model:params="params"
            :data="invoices"
            :columns="columns"
            :loading="loading"
            showSearch
            stickyHeader
            columnChooser
            mobileDevices
            storeSearch
            section="invoice"
            @fetch-data="populateData"
        >
          <template #cell-discountRate="{ value }">{{ value }} %</template>
          <template #cell-discount="{ value, row }">{{ value }} {{ row.cy }}</template>
          <template #cell-discountPrice="{ value, row }">{{ value }} {{ row.cy }}</template>
          <template #cell-vat="{ value }">{{ value }}%</template>
          <template #cell-vatPrice="{ value, row }">{{ value }} {{ row.cy }}</template>
          <template #cell-totalPrice="{ value, row }">{{ value }} {{ row.cy }}</template>
          <template #cell-pdf="{ row }">
            <div class="flex gap-1">
              <button type="button" class="btn btn-primary btn-sm me-1" @click="downloadFile(row.billId, 'LV')">
                <i class="bi bi-file-pdf"></i> LV
              </button>
              <button type="button" class="btn btn-primary btn-sm" @click="downloadFile(row.billId, 'EN')">
                <i class="bi bi-file-pdf"></i> EN
              </button>
            </div>
          </template>

          <template #filters>
            <DatePicker
              v-model="params.filter.date"
              range
              model-type="yyyy-MM-dd"
              class="col-12 col-lg-6 col-xl-4 col-xxl-3 col-sm-8 my-1"
              :multi-calendars="{ solo: true }"
              :enable-time-picker="false"
              @update:model-value="changeDate"
            />
          </template>
        </TableField>
      </div>
    </div>
  </div>
</template>

<script src="./Invoice.js"></script>
